import React, { useState } from "react";

// import Icon2 from "react-native-vector-icons/FontAwesome";

interface props {
	setSearch: (e: string) => void;
	search: string;
}
interface viewProps {
	height: number;
	width: number;
	x: number;
	y: number;
}
const SearchItem = ({ setSearch, search }: props) => {
	const [isFocus, setIsFocus] = useState(false);
	const [positionImage, setPositionImage] = useState<viewProps>({ height: 0, width: 0, x: 0, y: 0 });

	const handlerValue = (a: string) => {
		setSearch(a);
	};
	return (
		<>
			<div className="sortSerch">
				<p className="serchText">Szukaj</p>

				<div className="serchContainer">
					<input
						placeholder="... szukaj ..."
						autoComplete="off"
						maxLength={15}
						className={"inputSerch"}
						value={search}
						onChange={(e) => handlerValue(e.target.value)}
						onFocus={(e) => setSearch("")}
					></input>
				</div>
			</div>
		</>
	);
};

export default SearchItem;

// const styles = StyleSheet.create({
// 	container: {
// 		backgroundColor: "rgb(142, 184, 229)",
// 		flexDirection: "row",
// 		justifyContent: "center",
// 		alignItems: "center",

// 		padding: 5,
// 		width: 150,
// 		height: 50,
// 		marginTop: 10,
// 		borderWidth: 1,
// 		borderRadius: 12,
// 		// borderColor: "rgb(91, 92, 93)",
// 		borderColor: "rgb(100,100,100)",
// 	},

// 	textSzukaj: {
// 		position: "absolute",
// 		zIndex: 1,
// 		backgroundColor: "rgb(142, 184, 229)",
// 		fontSize: 16,
// 		fontWeight: "bold",
// 		paddingHorizontal: 5,
// 		borderRadius: 20,
// 	},
// 	text: {
// 		fontSize: 16,
// 		padding: 0,
// 		margin: 0,
// 		width: "95%",
// 		height: "95%",
// 		color: "black",
// 		alignItems: "center",
// 		justifyContent: "center",
// 		textAlign: "center",
// 		lineHeight: 16,
// 	},
// 	items: {
// 		flexDirection: "column",
// 		paddingTop: 14,
// 		paddingBottom: 10,
// 		gap: 7,
// 		alignItems: "center",
// 		// borderColor: "rgb(91, 92, 93)",
// 		borderColor: "rgb(100,100,100)",
// 	},
// 	selectedStyle: {
// 		fontWeight: "600",
// 	},

// 	icon: {
// 		marginRight: 5,
// 	},
// });
